/* EkDoTee theme script */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || (window.theme && window.theme.moneyFormat) || '{{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = format.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function showToast(message, isError) {
    var toast = document.getElementById('CartToast');
    if (!toast) return;
    toast.querySelector('[data-toast-msg]').textContent = message;
    toast.classList.toggle('is-error', !!isError);
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 4500);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-toast-close]')) document.getElementById('CartToast').hidden = true;
  });

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
      el.classList.remove('bump');
      void el.offsetWidth;
      el.classList.add('bump');
    });
  }

  /* ---------- Hero carousel ---------- */
  class HeroCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.bars = Array.from(this.querySelectorAll('[data-bar]'));
      this.counter = this.querySelector('[data-current]');
      this.index = 0;
      this.interval = (parseFloat(this.dataset.interval) || 6) * 1000;
      this.autoplay = this.dataset.autoplay === 'true' && !reduceMotion && this.slides.length > 1;
      this.style.setProperty('--hero-interval', this.interval / 1000 + 's');
      if (!this.autoplay) this.setAttribute('data-autoplay', 'false');

      var self = this;
      var prev = this.querySelector('[data-prev]');
      var next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () { self.go(self.index - 1); });
      if (next) next.addEventListener('click', function () { self.go(self.index + 1); });
      this.bars.forEach(function (bar, i) { bar.addEventListener('click', function () { self.go(i); }); });

      this.addEventListener('mouseenter', function () { self.pause(); });
      this.addEventListener('mouseleave', function () { self.resume(); });
      this.addEventListener('focusin', function () { self.pause(); });
      this.addEventListener('focusout', function () { self.resume(); });
      this.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') self.go(self.index - 1);
        if (e.key === 'ArrowRight') self.go(self.index + 1);
      });

      var startX = null, startY = null;
      this.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; startY = e.touches[0].clientY; }, { passive: true });
      this.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) self.go(self.index + (dx < 0 ? 1 : -1));
        startX = null;
      });

      document.addEventListener('visibilitychange', function () { document.hidden ? self.pause() : self.resume(); });

      this.blockSelect = function (e) {
        var i = self.slides.indexOf(e.target);
        if (i > -1) { self.paused = true; self.go(i, true); self.classList.add('is-paused'); }
      };
      this.blockDeselect = function (e) {
        if (self.slides.indexOf(e.target) > -1) { self.paused = false; self.classList.remove('is-paused'); self.schedule(); }
      };
      document.addEventListener('shopify:block:select', this.blockSelect);
      document.addEventListener('shopify:block:deselect', this.blockDeselect);

      this.go(0, true);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('shopify:block:select', this.blockSelect);
      document.removeEventListener('shopify:block:deselect', this.blockDeselect);
    }
    go(i, silent) {
      var n = this.slides.length;
      if (!n) return;
      this.index = (i + n) % n;
      var current = this.index;
      this.slides.forEach(function (slide, k) {
        var active = k === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) slide.removeAttribute('inert'); else slide.setAttribute('inert', '');
      });
      this.bars.forEach(function (bar, k) {
        bar.classList.remove('is-active');
        bar.classList.toggle('is-done', k < current);
        bar.setAttribute('aria-current', k === current ? 'true' : 'false');
      });
      var activeBar = this.bars[current];
      if (activeBar) { void activeBar.offsetWidth; activeBar.classList.add('is-active'); }
      if (this.counter) this.counter.textContent = String(current + 1).padStart(2, '0');
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.autoplay || this.paused) return;
      var self = this;
      this.timer = setTimeout(function () { self.go(self.index + 1); }, this.interval);
    }
    pause() {
      if (!this.autoplay) return;
      this.paused = true;
      this.classList.add('is-paused');
      clearTimeout(this.timer);
    }
    resume() {
      if (!this.autoplay || this.contains(document.activeElement)) return;
      this.paused = false;
      this.classList.remove('is-paused');
      var bar = this.bars[this.index];
      if (bar) { bar.classList.remove('is-active'); void bar.offsetWidth; bar.classList.add('is-active'); }
      this.schedule();
    }
  }
  if (!customElements.get('hero-carousel')) customElements.define('hero-carousel', HeroCarousel);

  /* ---------- Header: drawer, search, sticky hide ---------- */
  function initHeader() {
    var drawer = document.getElementById('MenuDrawer');
    var lastFocus;
    function openDrawer() {
      if (!drawer) return;
      lastFocus = document.activeElement;
      drawer.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      document.body.classList.add('no-scroll');
      document.querySelectorAll('[data-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var closeBtn = drawer.querySelector('[data-menu-close]');
      if (closeBtn) closeBtn.focus();
    }
    function closeDrawer() {
      if (!drawer || !drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open');
      document.body.classList.remove('no-scroll');
      document.querySelectorAll('[data-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      setTimeout(function () { drawer.hidden = true; }, 450);
      if (lastFocus) lastFocus.focus();
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-menu-open]')) { e.preventDefault(); openDrawer(); }
      if (e.target.closest('[data-menu-close]')) { e.preventDefault(); closeDrawer(); }

      var searchToggle = e.target.closest('[data-search-toggle]');
      if (searchToggle) {
        var bar = document.getElementById('SearchBar');
        if (bar) {
          e.preventDefault();
          bar.hidden = !bar.hidden;
          searchToggle.setAttribute('aria-expanded', String(!bar.hidden));
          if (!bar.hidden) bar.querySelector('input').focus();
        }
      }

      // Close open desktop dropdowns when clicking outside
      document.querySelectorAll('.header__nav details[open]').forEach(function (d) {
        if (!d.contains(e.target)) d.removeAttribute('open');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      closeDrawer();
      var bar = document.getElementById('SearchBar');
      if (bar && !bar.hidden) bar.hidden = true;
      document.querySelectorAll('.header__nav details[open], .facet[open]').forEach(function (d) { d.removeAttribute('open'); });
    });

    // Desktop dropdowns open on hover
    document.querySelectorAll('.header__nav details').forEach(function (d) {
      d.addEventListener('mouseenter', function () { if (window.matchMedia('(hover: hover)').matches) d.setAttribute('open', ''); });
      d.addEventListener('mouseleave', function () { if (window.matchMedia('(hover: hover)').matches) d.removeAttribute('open'); });
    });

    var wrapper = document.querySelector('[data-header-hide]');
    if (wrapper) {
      var lastY = window.scrollY;
      window.addEventListener('scroll', function () {
        var y = window.scrollY;
        if (y > lastY && y > 200) wrapper.classList.add('is-hidden');
        else wrapper.classList.remove('is-hidden');
        lastY = y;
      }, { passive: true });
    }
  }

  /* ---------- Product: variant picker ---------- */
  function initProduct(root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var picker = root.querySelector('[data-variant-picker]');
    var idInput = root.querySelector('[data-variant-id]');
    var addBtns = root.querySelectorAll('[data-add-button]');
    var priceEl = root.querySelector('[data-product-price]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var labels = { add: root.dataset.labelAdd || 'Add to bag', soldout: root.dataset.labelSoldout || 'Sold out', unavailable: root.dataset.labelUnavailable || 'Unavailable' };

    function selectedOptions() {
      if (!picker) return [];
      return Array.from(picker.querySelectorAll('[data-option]')).map(function (fs) {
        var checked = fs.querySelector('input:checked');
        var select = fs.querySelector('select');
        return checked ? checked.value : select ? select.value : null;
      });
    }

    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function markAvailability(opts) {
      if (!picker) return;
      picker.querySelectorAll('[data-option]').forEach(function (fs, pos) {
        fs.querySelectorAll('.option__value').forEach(function (wrap) {
          var input = wrap.querySelector('input');
          var test = opts.slice();
          test[pos] = input.value;
          var match = product.variants.find(function (v) {
            return v.options.every(function (o, i) { return i === pos ? o === input.value : (i < pos ? o === test[i] : true); }) && v.available;
          });
          wrap.classList.toggle('is-unavailable', !match);
        });
        var legendValue = fs.querySelector('[data-selected-value]');
        if (legendValue) legendValue.textContent = opts[pos];
      });
    }

    function setButtons(variant) {
      addBtns.forEach(function (btn) {
        var label = btn.querySelector('span') || btn;
        if (!variant) { btn.disabled = true; label.textContent = labels.unavailable; }
        else if (!variant.available) { btn.disabled = true; label.textContent = labels.soldout; }
        else { btn.disabled = false; label.textContent = labels.add; }
      });
    }

    function onChange() {
      var opts = selectedOptions();
      var variant = findVariant(opts);
      markAvailability(opts);
      setButtons(variant);
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      document.querySelectorAll('[data-sticky-variant-id]').forEach(function (i) { i.value = variant.id; });

      [priceEl, stickyPrice].forEach(function (el) {
        if (!el) return;
        var cur = el.querySelector('[data-price-current]');
        var cmp = el.querySelector('[data-price-compare]');
        var wrap = el.querySelector('[data-price]') || el;
        if (cur) cur.textContent = formatMoney(variant.price);
        var sale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (cmp) { cmp.textContent = sale ? formatMoney(variant.compare_at_price) : ''; cmp.hidden = !sale; }
        wrap.classList.toggle('price--sale', !!sale);
      });

      if (variant.featured_media) {
        var media = root.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        if (media) {
          var gallery = media.parentElement;
          if (window.matchMedia('(max-width: 989px)').matches) {
            gallery.scrollTo({ left: media.offsetLeft - gallery.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
          } else if (media !== gallery.firstElementChild) {
            gallery.insertBefore(media, gallery.firstElementChild);
          }
        }
      }

      if (root.dataset.updateUrl === 'true' && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    if (picker) {
      picker.addEventListener('change', onChange);
      onChange();
    }

    // Quantity buttons
    root.querySelectorAll('[data-qty]').forEach(initQty);

    // Size guide modal
    root.querySelectorAll('[data-modal-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var modal = document.getElementById(btn.dataset.modalOpen);
        if (modal && modal.showModal) modal.showModal();
      });
    });

    // Sticky add to bag on mobile
    var sticky = document.querySelector('[data-sticky-atc]');
    var mainBtn = root.querySelector('[data-add-button]');
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(mainBtn);
    }
  }

  function initQty(wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('[data-qty-btn]').forEach(function (b) {
      b.addEventListener('click', function () {
        var min = parseInt(input.min || '0', 10);
        var v = parseInt(input.value || '1', 10) + (b.dataset.qtyBtn === 'plus' ? 1 : -1);
        input.value = Math.max(min, v);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ---------- 8-bit +1 on add to bag ---------- */
  function plusOne(btn, type) {
    if (!btn || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!document.getElementById('plusOneStyle')) {
      var st = document.createElement('style'); st.id = 'plusOneStyle';
      st.textContent = '.plus-one{position:fixed;z-index:9999;pointer-events:none;display:flex;align-items:center;gap:6px;font:700 15px/1 ui-monospace,SFMono-Regular,Menlo,Consolas,monospace;letter-spacing:.06em;color:#141414;background:#D4FF3A;border:2px solid #141414;padding:6px 9px;box-shadow:3px 3px 0 #141414;animation:plusOne 1.1s steps(8,end) forwards}' +
        '.plus-one svg{width:16px;height:16px;display:block}' +
        '@keyframes plusOne{0%{opacity:0;transform:translate(-50%,0) scale(.6)}15%{opacity:1;transform:translate(-50%,-14px) scale(1.1)}75%{opacity:1;transform:translate(-50%,-56px) scale(1)}100%{opacity:0;transform:translate(-50%,-76px) scale(1)}}';
      document.head.appendChild(st);
    }
    var coin = '<svg viewBox="0 0 8 8" shape-rendering="crispEdges"><path fill="#141414" d="M2 0h4v1H2zM1 1h1v1H1zM6 1h1v1H6zM0 2h1v4H0zM7 2h1v4H7zM1 6h1v1H1zM6 6h1v1H6zM2 7h4v1H2z"/><path fill="#FFD23F" d="M2 1h4v1H2zM1 2h6v4H1zM2 6h4v1H2z"/><path fill="#141414" d="M3 2h2v1H3zM4 3h1v2H4zM3 5h2v1H3z"/></svg>';
    var r = btn.getBoundingClientRect();
    var el = document.createElement('div');
    el.className = 'plus-one'; el.setAttribute('aria-hidden', 'true');
    el.innerHTML = coin + '<span>+1 ' + (type === 'Badges' ? 'BADGE' : 'TEE') + '</span>';
    el.style.left = (r.left + r.width / 2) + 'px';
    el.style.top = (r.top - 8) + 'px';
    document.body.appendChild(el);
    setTimeout(function () { el.remove(); }, 1200);
  }

  /* ---------- AJAX add to bag ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form || document.body.dataset.cartType !== 'toast' || !window.fetch) return;
    e.preventDefault();
    var btn = e.submitter && e.submitter.matches('[data-add-button]') ? e.submitter : form.querySelector('[data-add-button]');
    if (btn) btn.classList.add('is-loading');
    var formData = new FormData(form);
    var qtyInput = document.querySelector('input[name="quantity"][form="' + form.id + '"]');
    if (qtyInput && !formData.has('quantity')) formData.append('quantity', qtyInput.value);

    fetch(window.theme.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add to bag');
        var title = res.data.product_title || 'Item';
        showToast(title + ' added to bag');
        plusOne(btn, res.data.product_type);
        return fetch(window.theme.routes.cart + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) { if (cart) updateCartCount(cart.item_count); })
      .catch(function (err) { showToast(err.message, true); })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  });

  /* ---------- Collection filters ---------- */
  function initFacets() {
    document.querySelectorAll('[data-facets-form]').forEach(function (form) {
      var t;
      form.addEventListener('change', function (e) {
        clearTimeout(t);
        var delay = e.target.type === 'number' ? 700 : 0;
        t = setTimeout(function () { form.submit(); }, delay);
      });
    });
    document.addEventListener('click', function (e) {
      document.querySelectorAll('.facet[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
    });
  }

  /* ---------- Cart page ---------- */
  function initCart() {
    var form = document.getElementById('CartForm');
    if (!form) return;
    form.querySelectorAll('[data-qty]').forEach(initQty);
    var t;
    form.addEventListener('change', function (e) {
      if (!e.target.matches('input[name="updates[]"]')) return;
      clearTimeout(t);
      t = setTimeout(function () {
        var update = document.createElement('input');
        update.type = 'hidden'; update.name = 'update'; update.value = '1';
        form.appendChild(update);
        form.submit();
      }, 500);
    });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window) || reduceMotion) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Customer addresses ---------- */
  function initAddresses() {
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-address-toggle]');
      if (toggle) {
        var target = document.getElementById(toggle.dataset.addressToggle);
        if (target) target.hidden = !target.hidden;
      }
      var del = e.target.closest('[data-address-delete]');
      if (del && window.confirm(del.dataset.confirm || 'Delete this address?')) {
        var f = document.createElement('form');
        f.method = 'post'; f.action = del.dataset.addressDelete;
        f.innerHTML = '<input type="hidden" name="_method" value="delete">';
        document.body.appendChild(f); f.submit();
      }
    });
  }

  /* ---------- Fit giant wordmark to width ---------- */
  function fitText() {
    document.querySelectorAll('[data-fit-text]').forEach(function (el) {
      var box = el.parentElement;
      var cs = getComputedStyle(box);
      var avail = box.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      el.style.fontSize = '';
      var current = parseFloat(getComputedStyle(el).fontSize);
      if (el.offsetWidth > 0) el.style.fontSize = Math.floor(current * avail / el.offsetWidth) + 'px';
    });
  }
  window.addEventListener('resize', fitText);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitText);

  function init() {
    fitText();
    initHeader();
    document.querySelectorAll('[data-product]').forEach(initProduct);
    initFacets();
    initCart();
    initReveal();
    initAddresses();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-product]').forEach(initProduct);
    e.target.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  });
})();
